import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Button, Typography } from "@material-ui/core";
import { Card, CardActions, CardContent, CardMedia } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  image: {
    height: 300,
    backgroundPosition: "center",
  },
  description: {
    paddingTop: theme.spacing(1),
  },
  card: {
    marginBottom: theme.spacing(2),
    border: `2px solid ${theme.palette.primary.main}`, // Add outline to the card
    borderRadius: "8px", // Rounded corners
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Add shadow for a pop-out effect
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: 600,
    minHeight: 600,
    transition: "transform 0.3s ease, box-shadow 0.3s ease", // Smooth transition for hover effects
    "&:hover": {
      transform: "scale(1.02)", // Slightly enlarge the card on hover
      boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)", // Add a more prominent shadow on hover
      borderColor: theme.palette.primary.main.dark, // Darken the border color on hover
    },
  },
  cardDescription: {
    color: theme.palette.grey[700],
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end", // Align button to the bottom-right
    padding: theme.spacing(2),
  },
  button: {
    backgroundColor: theme.palette.primary.main, // Make the button pop
    color: "white",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark, // Darker shade on hover
    },
  },
}));

// this is a custom component for the acquisition form
// it is a card with the satellite data and a button to choose the satellite
const AlgorithmCard = ({ name, image, description, onChoose, enabled }) => {
  // use the translation function from react-i18next
  const [t] = useTranslation();
  // use the styles from the useStyles hook
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardMedia
        className={classes.image}
        image={image}
        title={name}
        description={description}
      />
      <CardContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // Align vertically
            justifyContent: "center", // Optional: Center horizontally
            height: "50%", // Ensure it takes the full height of the container
          }}
        >
          <Typography gutterBottom variant="h5" component="h2">
            {name}
          </Typography>
        </Box>
        <Typography component="p" className={classes.cardDescription}>
          {description}
        </Typography>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button
          className={classes.button}
          onClick={onChoose}
          disabled={!enabled}
        >
          {t("forms.acquisition.1.card.choose")}
        </Button>
      </CardActions>
    </Card>
  );
};

export default AlgorithmCard;
